import { Listing, TradeRecord, WithdrawalRecord } from './marketplaceTypes';

export const INITIAL_LISTINGS: Listing[] = [
  {
    id: 'mk-1001',
    title: 'Facebook Group Seeding Account - Tier A',
    type: 'seeding',
    seller: 'SeedingPro Team',
    credits: 420,
    banner: 'Ưu tiên top tương tác trong 30 ngày',
    description: 'Tài khoản đã warm up, phù hợp triển khai seeding group ngách mỹ phẩm.',
    status: 'active',
    createdAt: '2026-06-02 08:00',
    updatedAt: '2026-06-02 08:00',
  },
  {
    id: 'mk-1002',
    title: 'TikTok Engagement Account Bundle',
    type: 'seeding',
    seller: 'SocialScale Studio',
    credits: 310,
    banner: 'Bộ 05 tài khoản theo niche Lifestyle',
    description: 'Profile sạch, lịch sử đăng ổn định, sẵn sàng cho chiến dịch kéo reach.',
    status: 'pending',
    createdAt: '2026-06-02 08:20',
    updatedAt: '2026-06-02 08:20',
  },
  {
    id: 'mk-2001',
    title: 'AI Content Generator Account - 30 Days',
    type: 'ai',
    seller: 'AICreator Hub',
    credits: 560,
    banner: 'Gói AI tốc độ cao - 1 tháng',
    description: 'Tối ưu cho viết nội dung đa nền tảng, phù hợp team content 3-5 người.',
    status: 'active',
    createdAt: '2026-06-02 09:00',
    updatedAt: '2026-06-02 09:00',
  },
  {
    id: 'mk-2002',
    title: 'AI Chat Automation Account - Premium',
    type: 'ai',
    seller: 'Conversa Lab',
    credits: 690,
    banner: 'Premium automation cho CSKH',
    description: 'Bao gồm template hội thoại và kịch bản xử lý lead theo ngành.',
    status: 'active',
    createdAt: '2026-06-02 09:30',
    updatedAt: '2026-06-02 09:30',
  },
];

export const INITIAL_TRADES: TradeRecord[] = [
  {
    id: 'tr-9001',
    side: 'buy',
    title: 'AI Content Generator Account - 30 Days',
    counterparty: 'AICreator Hub',
    credits: 560,
    status: 'completed',
    time: '2026-06-02 10:15',
    orderRef: 'ORD-20260602-9001',
  },
  {
    id: 'tr-9002',
    side: 'sell',
    title: 'Combo Seeding Group Retail',
    counterparty: 'Studio Lemon',
    credits: 450,
    status: 'escrow',
    time: '2026-06-02 11:30',
    orderRef: 'ORD-20260602-9002',
  },
  {
    id: 'tr-9003',
    side: 'sell',
    title: 'AI Chat Automation Account - Standard',
    counterparty: 'Nova Team',
    credits: 380,
    status: 'refunded',
    time: '2026-06-01 18:45',
    orderRef: 'ORD-20260601-9003',
  },
  {
    id: 'tr-9004',
    side: 'sell',
    title: 'Tài khoản Seeding Logistics Tier B',
    counterparty: 'Peak Media',
    credits: 620,
    status: 'completed',
    time: '2026-06-01 14:00',
    orderRef: 'ORD-20260601-9004',
  },
];

export const INITIAL_WITHDRAWALS: WithdrawalRecord[] = [
  {
    id: 'wd-7001',
    amount: 300,
    status: 'pending',
    destination: 'VIB - ****2833',
    createdAt: '2026-06-02 09:20',
    requestRef: 'WDR-20260602-7001',
  },
];
